import { IconButtonSizeMap } from '../../constants'

export const iconButtonStyle = {
  icon: props => ({
    margin: props.margin || IconButtonSizeMap[props.size].margin,
    fontSize: IconButtonSizeMap[props.size].fontSize
  })
}
